const projectType = {
    productType: [
        {
            id: 'EWB',
            value: "电子白板"
        }, {
            id: 'TCM',
            value: "触控一体机"
        }, {
            id: 'LCD',
            value: "LCD拼接屏"
        }, {
            id: 'LED',
            value: "LED拼接屏"
        }, {
            id: 'PRM',
            value: "投影机"
        }
    ],
    serviceType: [
        {
            id: 'install',
            value: "安装"
        }, {
            id: 'operations',
            value: "运维"
        }, {
            id: 'other',
            value: "其它"
        }
    ]
};
export default projectType;


// WEBPACK FOOTER //
// ./src/libs/projectType.js